import EmailValidator from 'email-validator';

export default function validate(values) {
    let errors = {};

    if(!values.account.companyName) {
        errors.companyName = 'missingCompanyName'
    }

    if(values.account.accountSecurity.type === 'USERNAME' && !values.administrator.username) {
        errors.username = 'missingUsername'
    }

    if(values.account.accountSecurity.type === 'USERNAME' && !values.administrator.password) {
        errors.password = 'missingPassword'
    }

    if(!values.account.shippingAddress.street1) {
        if(!errors.shippingAddress){errors.shippingAddress = {}}
        errors.shippingAddress.street1 = 'missingStreet'
    }

    if(!values.account.shippingAddress.city) {
        if(!errors.shippingAddress){errors.shippingAddress = {}}
        errors.shippingAddress.city = 'missingCity'
    }

    if(!values.account.shippingAddress.state) {
        if(!errors.shippingAddress){errors.shippingAddress = {}}
        errors.shippingAddress.state = 'missingState'
    }

    if(!values.account.shippingAddress.zipcode) {
        if(!errors.shippingAddress){errors.shippingAddress = {}}
        errors.shippingAddress.zipcode = 'missingZip'
    }

    if(!values.account.shippingAddress.country) {
        if(!errors.shippingAddress){errors.shippingAddress = {}}
        errors.shippingAddress.country = 'missingCountry'
    }

    if(!values.account.billingAddress.street1) {
        if(!errors.billingAddress){errors.billingAddress = {}}
        errors.billingAddress.street1 = 'missingStreet'
    }

    if(!values.account.billingAddress.city) {
        if(!errors.billingAddress){errors.billingAddress = {}}
        errors.billingAddress.city = 'missingCity'
    }

    if(!values.account.billingAddress.state) {
        if(!errors.billingAddress){errors.billingAddress = {}}
        errors.billingAddress.state = 'missingState'
    }

    if(!values.account.billingAddress.zipcode) {
        if(!errors.billingAddress){errors.billingAddress = {}}
        errors.billingAddress.zipcode = 'missingZip'
    }

    if(!values.account.billingAddress.country) {
        if(!errors.billingAddress){errors.billingAddress = {}}
        errors.billingAddress.country = 'missingCountry'
    }

    if(!values.administrator.firstName) {
        errors.firstName = 'missingFirstName'
    }

    if(!values.administrator.lastName) {
        errors.lastName = 'missingLastName'
    }

    if(values.account.accountSecurity.type === 'EMAIL' && !EmailValidator.validate(values.administrator.emailAddress)) {
        errors.emailAddress = 'missingEmail'
    }

    // for(let i = 0; i < values.account.phoneNumbers; i++) {
    //     let phoneNumber = values.account.phoneNumbers[i];
    //     if(!phoneNumber) {
    //         errors.phoneNumbers.push('missingPhoneNumber');
    //     } else {
    //         errors.phoneNumbers.push('');
    //     }
    // }

    return errors;
}
